import { Navigate } from 'react-router-dom';
import { PermissionGuard } from '@/auth/guard';
import { OrionAccess, OrionModule, OrionSubmodule } from '@/types';
import {
  OrderListPage,
  OrderEditPage,
  OrderCreatePage,
  RequestListPage,
  RequestEditPage,
  RequestCreatePage,
  RequestUserListView,
  RequestUserDetailView,
} from './imports';
import BillingOrderListPage from '@pages/management/accounts/billing-orders/list';
import BillingOrderCreatePage from '@pages/management/accounts/billing-orders/new';
import BillingOrderEditPage from '@pages/management/accounts/billing-orders/edit';
import BillingOrderInformationPage from '@pages/management/accounts/billing-orders/information';

export const orderRoutes = [
  {
    path: 'orders',
    children: [
      // Purchase orders (index)
      {
        element: (
          <PermissionGuard
            hasContent
            module={OrionModule.ACCOUNT}
            submodule={OrionSubmodule.ACCOUNT.ORDER}
            access={OrionAccess.VIEW}
          >
            <OrderListPage />
          </PermissionGuard>
        ),
        index: true,
      },
      {
        path: 'list',
        element: (
          <PermissionGuard
            hasContent
            module={OrionModule.ACCOUNT}
            submodule={OrionSubmodule.ACCOUNT.ORDER}
            access={OrionAccess.VIEW}
          >
            <OrderListPage />
          </PermissionGuard>
        ),
      },
      {
        path: 'new',
        element: (
          <PermissionGuard
            hasContent
            module={OrionModule.ACCOUNT}
            submodule={OrionSubmodule.ACCOUNT.ORDER}
            access={OrionAccess.CREATE}
          >
            <OrderCreatePage />
          </PermissionGuard>
        ),
      },
      {
        path: ':id/edit',
        element: (
          <PermissionGuard
            hasContent
            module={OrionModule.ACCOUNT}
            submodule={OrionSubmodule.ACCOUNT.ORDER}
            access={OrionAccess.VIEW}
          >
            <OrderEditPage />
          </PermissionGuard>
        ),
      },

      // Billing orders
      {
        path: 'billing',
        children: [
          {
            element: (
              <PermissionGuard
                hasContent
                module={OrionModule.ACCOUNT}
                submodule={OrionSubmodule.ACCOUNT.BILLING_ORDER}
                access={OrionAccess.VIEW}
              >
                <BillingOrderListPage />
              </PermissionGuard>
            ),
            index: true,
          },
          {
            path: 'new',
            element: (
              <PermissionGuard
                hasContent
                module={OrionModule.ACCOUNT}
                submodule={OrionSubmodule.ACCOUNT.BILLING_ORDER}
                access={OrionAccess.CREATE}
              >
                <BillingOrderCreatePage />
              </PermissionGuard>
            ),
          },
          {
            path: ':id/edit',
            element: (
              <PermissionGuard
                hasContent
                module={OrionModule.ACCOUNT}
                submodule={OrionSubmodule.ACCOUNT.BILLING_ORDER}
                access={OrionAccess.UPDATE}
              >
                <BillingOrderEditPage />
              </PermissionGuard>
            ),
          },
          {
            path: ':orderId/information',
            element: (
              <PermissionGuard
                hasContent
                module={OrionModule.ACCOUNT}
                submodule={OrionSubmodule.ACCOUNT.BILLING_ORDER}
                access={OrionAccess.UPDATE}
              >
                <BillingOrderInformationPage />
              </PermissionGuard>
            ),
          },
        ],
      },

      // Requests
      {
        path: 'requests',
        children: [
          {
            element: (
              <PermissionGuard
                hasContent
                module={OrionModule.ACCOUNT}
                submodule={OrionSubmodule.ACCOUNT.REQUEST}
                access={OrionAccess.VIEW}
              >
                <RequestListPage />
              </PermissionGuard>
            ),
            index: true,
          },
          {
            path: 'new',
            element: (
              <PermissionGuard
                hasContent
                module={OrionModule.ACCOUNT}
                submodule={OrionSubmodule.ACCOUNT.REQUEST}
                access={OrionAccess.CREATE}
              >
                <RequestCreatePage />
              </PermissionGuard>
            ),
          },
          {
            path: ':id/edit',
            element: (
              <PermissionGuard
                hasContent
                module={OrionModule.ACCOUNT}
                submodule={OrionSubmodule.ACCOUNT.REQUEST}
                access={OrionAccess.UPDATE}
              >
                <RequestEditPage />
              </PermissionGuard>
            ),
          },
        ],
      },

      // Access (user approval)
      {
        path: 'access',
        children: [
          {
            element: (
              <PermissionGuard
                hasContent
                module={OrionModule.ACCOUNT}
                submodule={OrionSubmodule.ACCOUNT.REQUEST}
                access={OrionAccess.VIEW}
              >
                <RequestUserListView />
              </PermissionGuard>
            ),
            index: true,
          },
          {
            path: ':id/detail',
            element: (
              <PermissionGuard
                hasContent
                module={OrionModule.ACCOUNT}
                submodule={OrionSubmodule.ACCOUNT.REQUEST}
                access={OrionAccess.VIEW}
              >
                <RequestUserDetailView />
              </PermissionGuard>
            ),
          },
          {
            path: ':id/edit',
            element: (
              <PermissionGuard
                hasContent
                module={OrionModule.ACCOUNT}
                submodule={OrionSubmodule.ACCOUNT.REQUEST}
                access={OrionAccess.UPDATE}
              >
                <RequestEditPage />
              </PermissionGuard>
            ),
          },
        ],
      },
    ],
  },
];
